module.exports = __webpack_public_path__ + "img/poster2.2af274f3.jpg";